import * as types from "../constants/actionTypes";

export const availabilityReducer = (state = 0, action) => {
  switch (action.type) {
    case types.RATE_SELECTED:
      return state > 0 ? state - 1 : 0;
    case types.RATE_UNSELECTED:
      return state + 1;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/availabilityReducer.js